import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import Init from "./Init";
import * as serviceWorker from "./serviceWorker";
import Test2 from "../src/components/Test2";
import TestRev from "./components/Web/TestRev";
import TestForm from "./components/Web/TestForm";
import "antd/dist/antd.css";

import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

ReactDOM.render(<Init />, document.getElementById("root"));

serviceWorker.unregister();
